import React, { useEffect, useState } from 'react';
import Page from './Page';
import './AssessPage.scss'; // Assuming you have a CSS file for styles
import { getProductCategoriesData, getProductCategoriesDataClear } from '../../redux/courses/actions';
import { convertHoursToMins, convertTimeFormat, getProcureInfo, redirectToPageUtil, SessionKeys } from '../../utils/AppUtils';
import { t } from 'i18next';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader/Loader';
import NotFoundComponent from '../../components/NewDesign/NotFound/NotFoundComponent';

const MoneyMatrics = () => {

	const dispatch = useDispatch();
		const navigate = useNavigate();
		const authBroker = useSelector((state) => state.auth.authBroker);
		var assessRes = useSelector((state) => state.courses.productCategoriesData);
		const [myAssetList, setMyAssetList] = useState([]);
		const [courseData, setCourseData] = useState({});
		const [isLoading, setIsLoading] = useState(false);
	
	
		useEffect(() => {
			setIsLoading(true);
			dispatch(
				getProductCategoriesData({
					module: "getProductCategoriesData",
					postData:
					{
						token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
						category_id: [],
						provider_id: "",
						search: "",
						sort: 5,
						page_size: 0,
						page: 1,
						popular_tab: false,
						popular_days: "",
						isAll: false,
						language: "",
						brokerage_id: localStorage.getItem(SessionKeys.COMPANY_ID),
						filter: 0,
						asset_id: ["6"],
						pillar_id: ""
					}
	
				})
			);
		}, [dispatch])
	
		useEffect(() => {
			if (!_.isEmpty(assessRes)) {
				console.log("MY COURSES", assessRes);
				setIsLoading(false);
				if (assessRes.status === "success") {
					const cListPayload = assessRes.payload.payload;
					if (!_.isEmpty(cListPayload)) {
						const cList = cListPayload.courseList;
						for (let course of cList) {
							if (course.durationUnit === "Hours") {
								course.duration = convertHoursToMins(course.duration);
							}
							course.duration = convertTimeFormat(course.duration, true);
							course.durationUnit = "";
						}
						console.log("MY COURSES--", cList);
	
						let prodArr = [];
						for (let course of cList) {
							let tags = [];
							let btnTitle = t("Start course");
							if (course.provider?.provider_display_name) {
								tags.push(course.provider.provider_display_name);
							}
							tags.push("Course");
							if (course.lessons) {
								tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
							}
							if (course.duration) {
								tags.push(`${course.duration} ${course.durationUnit}`);
							}
							if (course.views) {
								tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
							}
							if (course.crs_progress > 0 && course.crs_progress < 100) {
								btnTitle = t("Resume course");
							} else if (course.crs_progress >= 100) {
								btnTitle = t("Revisit course");
							}
							let priceInfo = getProcureInfo(course.purchased_info);
							course.is_home = true;
							setMyAssetList([]);
							prodArr.push({
								id: course?.courseId,
								is_like: course?.is_like ? course?.is_like : false,
								is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
								dbId: course?.list_id,
								productType: course?.typ,
								productOrigin: course?.source,
								title: course.name,
								logoURL: course.provider?.provider_img
									? course.provider?.provider_img
									: "",
								bannerURL: course.imageURL,
								tagsArray: tags,
								description: course.short_description,
								btnTitle: btnTitle,
								progress: course.crs_progress,
								showLikeMenu: true,
								btnAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
								descAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
								bannerAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
								footerLineComp: "",
								showHeader: true,
								showBody: course.short_description ? true : false,
								showFooter: true,
								showProgress: false,
								cardClassName: "",
								rightBtnIcon: "/images/arrow-right.svg",
								lefttBtnIcon: "",
								priceInfo,
								status: course.crs_status,
								asset_type: course.asset_name,
								duration: course.duration,
								completion_date: course.completion_date,
							});
						}
						setMyAssetList(prodArr);
	
						dispatch(getProductCategoriesDataClear({}));
	
					}
				}
	
			}
		}, [assessRes]);
	


    return (
        <Page>
        <>
		<Loader start = {isLoading} />
            <main class="calculator-sec assessment-sec">
    <section class="calculator-head-box">
		<h2>Money Metrics</h2>
		<p>Discover how you compare! With a few simple inputs, we'll help you see where you stand when it comes to managing your money.</p>
    </section>
	  {myAssetList.length === 0  ? <NotFoundComponent showMsg={true} />
						:myAssetList.map((course, i) => {
							console.log("COURSE334454", course);
							return (
								<div class="card">
									<div className='d-flex gap-2 justify-content-between titlboxm'>
										<div className='left-boxacc d-flex'>
											<span className="icon-box">
												<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M11.022 22C12.518 22 13.948 21.7067 15.312 21.12C16.632 20.5627 17.798 19.7707 18.81 18.744C19.822 17.732 20.5993 16.5733 21.142 15.268C21.714 13.904 22 12.474 22 10.978C22 9.482 21.7067 8.052 21.12 6.688C20.5627 5.368 19.7707 4.202 18.744 3.19C17.732 2.178 16.5733 1.40067 15.268 0.857999C13.904 0.286 12.474 0 10.978 0C9.482 0 8.052 0.293333 6.688 0.879999C5.38267 1.43733 4.21667 2.22933 3.19 3.256C2.178 4.268 1.40067 5.42667 0.858 6.732C0.286 8.096 0 9.51867 0 11C0 12.4813 0.278667 13.8967 0.836 15.246C1.39333 16.5807 2.19267 17.7613 3.234 18.788C4.27533 19.8293 5.47067 20.6213 6.82 21.164C8.16933 21.7213 9.57 22 11.022 22ZM10.978 1.364C12.7233 1.364 14.344 1.804 15.84 2.684C17.292 3.52 18.4433 4.664 19.294 6.116C20.1887 7.612 20.636 9.23267 20.636 10.978C20.636 12.7233 20.196 14.344 19.316 15.84C18.48 17.292 17.336 18.4433 15.884 19.294C14.388 20.1887 12.7673 20.636 11.022 20.636C9.27667 20.636 7.656 20.196 6.16 19.316C4.708 18.48 3.55667 17.336 2.706 15.884C1.826 14.388 1.386 12.7673 1.386 11.022C1.386 9.27667 1.81867 7.656 2.684 6.16C3.52 4.708 4.664 3.55667 6.116 2.706C7.612 1.81133 9.23267 1.364 10.978 1.364ZM13.816 11C13.3467 10.5747 12.606 10.252 11.594 10.032V7.898C11.814 7.91267 12.012 8.008 12.188 8.184C12.3933 8.43333 12.496 8.712 12.496 9.02H14.212C14.1973 8.68267 14.124 8.36733 13.992 8.074C13.86 7.766 13.6767 7.49467 13.442 7.26C12.9433 6.80533 12.3347 6.54133 11.616 6.468V5.5H10.626V6.49C10.274 6.51933 9.93667 6.6 9.614 6.732C9.29133 6.864 9.00533 7.04733 8.756 7.282C8.50667 7.502 8.316 7.766 8.184 8.074C8.052 8.382 7.986 8.70467 7.986 9.042C7.986 9.46733 8.08133 9.84867 8.272 10.186C8.448 10.4793 8.69 10.714 8.998 10.89C9.23267 11.022 9.46 11.132 9.68 11.22C9.768 11.2493 10.0027 11.3227 10.384 11.44L10.626 11.506V14.014C10.318 13.9553 10.0613 13.794 9.856 13.53C9.60667 13.222 9.48933 12.8847 9.504 12.518V12.496H7.788C7.80267 12.9067 7.89067 13.2953 8.052 13.662C8.21333 14.0287 8.43333 14.3587 8.712 14.652C9.25467 15.1507 9.9 15.422 10.648 15.466V16.5H11.616V15.466C12.1147 15.4513 12.6133 15.312 13.112 15.048C13.552 14.828 13.904 14.5053 14.168 14.08C14.4027 13.6987 14.52 13.3027 14.52 12.892C14.5347 12.54 14.4833 12.2027 14.366 11.88C14.2487 11.5427 14.0653 11.2493 13.816 11ZM9.966 9.482C9.79 9.32067 9.702 9.11533 9.702 8.866C9.702 8.558 9.80467 8.316 10.01 8.14C10.186 7.99333 10.3913 7.90533 10.626 7.876V9.79C10.406 9.73133 10.186 9.62867 9.966 9.482ZM12.43 13.684C12.21 13.8893 11.9387 14.014 11.616 14.058V11.77C11.968 11.858 12.2613 11.9973 12.496 12.188C12.7307 12.3787 12.8333 12.6133 12.804 12.892C12.8187 13.2 12.694 13.464 12.43 13.684Z" fill="#252525" />
												</svg>
											</span>
											<h3 class="money">{course.title}</h3>
										</div>
									
									{course.completion_date?<div className='badsec'><span class="badge">Completed {course?.completion_date}</span></div>:""}
									</div>
									<p className='mb-para' dangerouslySetInnerHTML={{
										__html: course?.description,
									}}></p>
									<p class="small">We'll guide you on the information you'll need to input with helpfull tips along the way.</p>
									<a href="#" tabIndex={0} aria-label="Start" class="button" onClick={()=>{course.btnAction();}}>Start <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M14.08 7.50374L8.576 1.98374C8.48 1.88774 8.432 1.77041 8.432 1.63174C8.432 1.49308 8.48 1.37574 8.576 1.27974C8.672 1.18374 8.78933 1.13574 8.928 1.13574C9.06667 1.13574 9.184 1.18374 9.28 1.27974L16 7.99974L9.28 14.7197C9.184 14.8157 9.06667 14.8637 8.928 14.8637C8.78933 14.8637 8.672 14.8157 8.576 14.7197C8.48 14.6237 8.432 14.5064 8.432 14.3677C8.432 14.2291 8.48 14.1117 8.576 14.0157L14.08 8.49574H0.496C0.357333 8.49574 0.24 8.44774 0.144 8.35174C0.048 8.25574 0 8.13841 0 7.99974C0 7.86108 0.048 7.74374 0.144 7.64774C0.24 7.55174 0.357333 7.50374 0.496 7.50374H14.08Z" fill="#415385" />
									</svg>
									</a>
								</div>

							);
						})
					}

	  
	
  </main>
        </>
        </Page>
    );
};

export default MoneyMatrics;